import { Link } from "react-router";
import { styled } from "@mui/material";

const getBaseLinkStyles = (theme: any) => ({
  display: 'block',
  fontSize: theme.typography.body2.fontSize,
  fontFamily: theme.typography.fontFamily,
  padding: '0 4px',
  maxWidth: '100%',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',

  '&.empty': {
    color: theme.palette.text.disabled,
    fontStyle: 'italic',
    cursor: 'default',
  }
});

export const StyledLink = styled(Link, {
  shouldForwardProp: (prop) => !['color', 'underline'].includes(prop.toString()),
})<{
  color?: string;
  underline?: 'always' | 'hover' | 'none';
}>(({ theme, color, underline }) => ({
  ...getBaseLinkStyles(theme),
  color: color || theme.palette.primary.main,
  textDecoration: underline === 'always' ? 'underline' : 'none',

  '&:hover:not(.empty)': {
    textDecoration: underline !== 'none' ? 'underline' : 'none',
    color: color ? theme.palette.augmentColor({ color: { main: color } }).dark : theme.palette.primary.dark,
  },
}));

export const StyledModalLink = styled('span', {
  shouldForwardProp: (prop) => !['color', 'underline'].includes(prop.toString()),
})<{
  color?: string;
  underline?: 'always' | 'hover' | 'none';
}>(({ theme, color, underline }) => ({
  ...getBaseLinkStyles(theme),
  color: color || theme.palette.primary.main,
  textDecoration: underline === 'always' ? 'underline' : 'none',
  cursor: 'pointer',

  '&:hover:not(.empty)': {
    textDecoration: underline !== 'none' ? 'underline' : 'none',
    color: color ? theme.palette.augmentColor({ color: { main: color } }).dark : theme.palette.primary.dark,
  },
}));
